//* ============================ INFOS ============================
export type CommissionPartnerInfo = {
  id: string
  firstName: string
  lastName: string
  fullName: string
  email: string
  organization: string
  active: boolean
  partnerType: PartnerType
}
//* ============================ RESPONSES ========================
export type CommissionPartnerSingletonResponse = {
  commissionPartner: CommissionPartnerInfo
}

export type CommissionPartnerListResponse = {
  commissionPartners: CommissionPartnerInfo[]
}

export type CommissionPartnerExistsResponse = {
  commissionPartnerId: string
  exists: boolean
  availableFor: AvailableFor
}
//* ============================ REQUESTS =========================
export type CreateCommissionPartnerRequest = {
  firstName: string
  lastName: string
  email: string
  organization: string
  partnerType: PartnerType
}

export type UpdateCommissionPartnerRequest = {
  firstName?: string
  lastName?: string
  email?: string
  organization?: string
  partnerType?: PartnerType
}
//* ============================ PARAMS ===========================
export type GetCommissionPartnerListQueryParams = {
  q?: string
  name?: string
  sort?: string
  email?: string
  organization?: string
  partnerType?: PartnerType
}
//* ============================ UTILS ============================
export enum PartnerType {
  REFERRAL_PARTNER = 'REFERRAL_PARTNER',
}

export enum AvailableFor {
  CREATE = 'CREATE',
  CONNECT = 'CONNECT',
  NOTHING = 'NOTHING',
}

export enum ManageRelation {
  CONNECT = 'CONNECT',
  DISCONNECT = 'DISCONNECT',
}
